export const DEPARTMENTS = {
  SALES: 'sales',
  HR: 'hr',
  STAFFING_SALES: 'staffing_sales',
  OTHER: 'other'
};

export const ROLES = {
  ADMIN: 'admin',
  MANAGER: 'manager',
  EMPLOYEE: 'employee'
};

export const LEAD_STATUS = {
  NEW: 'new',
  CONTACTED: 'contacted',
  IN_PROGRESS: 'in_progress',
  WON: 'won',
  LOST: 'lost'
};

export const HR_REQUIREMENT_STATUS = {
  OPEN: 'open',
  IN_PROGRESS: 'in_progress',
  CLOSED: 'closed'
};

export const HR_CANDIDATE_STATUS = {
  APPLIED: 'applied',
  SCREENING: 'screening',
  INTERVIEW: 'interview',
  SELECTED: 'selected',
  REJECTED: 'rejected'
};

export const STAFFING_REQUIREMENT_STATUS = {
  INITIATED: 'initiated',
  IN_PROGRESS: 'in_progress',
  ONHOLD: 'onhold',
  CLOSED: 'closed'
};

export const STAFFING_CANDIDATE_STATUS = {
  INITIATED: 'initiated',
  UNDER_PROCESS: 'under_process',
  ONHOLD: 'onhold',
  REJECTED: 'rejected',
  ONBOARDED: 'onboarded'
};

export const PROJECT_STATUS = {
  ACTIVE: 'active',
  ON_HOLD: 'on_hold',
  COMPLETED: 'completed'
};

export const TASK_STATUS = {
  TODO: 'todo',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  BLOCKED: 'blocked'
};

export const TASK_PRIORITY = {
  LOW: 'low',
  MEDIUM: 'medium',
  HIGH: 'high'
};

export const COMMENT_ENTITY_TYPES = {
  LEAD: 'lead',
  HR_REQUIREMENT: 'hr_requirement',
  HR_CANDIDATE: 'hr_candidate',
  STAFFING_REQUIREMENT: 'staffing_requirement',
  STAFFING_CANDIDATE: 'staffing_candidate',
  PROJECT: 'project',
  TASK: 'task'
};
